import {Box, Link, Typography} from "@mui/material"
import React from "react"
import {useNavigate} from "react-router-dom"
import {AppButton, AppSecondaryButton} from "@app-core/AppButton"
import {
  SUPPORT_EMAIL,
  SUPPORT_PHONE,
  SUPPORT_PHONE_TEL
} from "data/constants/support"
import {LOGO_BLUE, NAVY} from "theme"

interface AuriPlaceholderProps {
  // Optional overrides so each touchpoint (denied path, YES follow-ups, LST)
  // can tailor the copy. Sensible generic defaults otherwise.
  title?: string
  message?: string
  onBack?: () => void
}

// Hand-off / block screen shown wherever the brief expects Auri to "pop in"
// while the Auri feature flag is off. Keeps those paths from dead-ending: it
// reassures the user a specialist will follow up and offers a way back.
export const AuriPlaceholder: React.FC<AuriPlaceholderProps> = (
  props: AuriPlaceholderProps
) => {
  const {
    title = "We'll take it from here.",
    message = "A Benefits2 specialist will review your situation and follow up with you about the next steps.",
    onBack
  } = props
  const navigate = useNavigate()

  const onReturnHome = () => {
    navigate("/")
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      textAlign="center"
      minHeight="480px"
      paddingX={{xs: 3, sm: 6}}
      paddingY={6}
      gap={3}
    >
      <Box maxWidth="640px">
        <Typography
          component="h1"
          fontWeight="bold"
          fontSize="24px"
          color={NAVY}
          gutterBottom
        >
          {title}
        </Typography>
        <Typography component="p" fontSize="18px" color={NAVY}>
          {message}
        </Typography>
      </Box>

      <Box
        display="flex"
        flexDirection={{xs: "column", sm: "row"}}
        gap={2}
        width={{xs: "100%", sm: "auto"}}
      >
        {onBack && (
          <AppSecondaryButton onClick={onBack} sx={{minWidth: "160px"}}>
            Back
          </AppSecondaryButton>
        )}
        <AppButton onClick={onReturnHome} sx={{minWidth: "200px"}}>
          Return to Dashboard
        </AppButton>
      </Box>

      <Typography component="p" fontSize="16px" color={NAVY}>
        Questions? Email{" "}
        <Link href={`mailto:${SUPPORT_EMAIL}`} sx={{color: LOGO_BLUE}}>
          {SUPPORT_EMAIL}
        </Link>{" "}
        or call/text{" "}
        <Link href={`tel:${SUPPORT_PHONE_TEL}`} sx={{color: LOGO_BLUE}}>
          {SUPPORT_PHONE}
        </Link>
        .
      </Typography>
    </Box>
  )
}

export default AuriPlaceholder
